import './RedirectMessage.scss';

export function RedirectMessage() {
    return (
        <div className="RedirectMessage">
            <div className="RedirectMessage__inner">Redirecting...</div>
        </div>
    );
}
